export default __webpack_public_path__ + "static/media/virus4.f5be5bca.png";